import React from 'react';
import { castArray } from 'lodash';
import { FILTERS_LOCATION } from '@fiverr-private/listing_lib';
import type { ActiveSideFiltersType } from '@fiverr-private/listing_types';
import { BI_SOURCES } from '../../../../../../utils/constants';
import { applyTopBarFilters } from '../../../utils';
import { PillButton } from '../../../../pill_button';

interface PriorityFilterOptionProps {
    filterId: string;
    id: string;
    alias?: string;
    selected: boolean;
    groupName?: number;
    activeFilters: ActiveSideFiltersType;
}

export const PriorityFilterOption = ({
    filterId,
    id,
    alias,
    selected,
    groupName,
    activeFilters,
}: PriorityFilterOptionProps) => {
    const onClick = () => {
        const currentValues: string[] = castArray(activeFilters[filterId] || []);

        const newValues = selected ? currentValues.filter((value) => value !== id) : [...currentValues, id];

        applyTopBarFilters(
            { [filterId]: newValues },
            activeFilters,
            groupName,
            FILTERS_LOCATION.FLOATING_TOP,
            BI_SOURCES.VISUAL_FILTERS
        );
    };

    return (
        <PillButton isActive={selected} onClick={onClick}>
            {alias}
        </PillButton>
    );
};
